import React from 'react';
import styled from '@emotion/styled';
import OtherBankPeriod from '../select/OtherBankPeriod';

const Base = styled.div`
  display: flex;
  align-items: center;
`;

/**
 *  타금융사 할부조건 기간 컨텐츠 컴포넌트
 *  */
function OtherBankPeriodContents(): JSX.Element {
  return (
    <Base>
      <OtherBankPeriod />
    </Base>
  );
}

export default OtherBankPeriodContents;
